import { render, staticRenderFns } from "./enduranceText.vue?vue&type=template&id=64d05b04&scoped=true"
import script from "./enduranceText.vue?vue&type=script&lang=js"
export * from "./enduranceText.vue?vue&type=script&lang=js"
import style0 from "./enduranceText.vue?vue&type=style&index=0&id=64d05b04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d05b04",
  null
  
)

export default component.exports